import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import NotFound from '@/views/NotFound/index.vue'
import Forbidden from '@/views/Forbidden/index.vue'
import { Component } from 'vue-property-decorator'
import DashboardLayout from '@/components/Layout/index.vue'
import api from '@/helpers/fetch'

Component.registerHooks([
	'beforeRouteEnter',
	'beforeRouteUpdate',
	'beforeRouteLeave',
])

Vue.use(VueRouter)

const routesHomes: Array<RouteConfig> = [
	/**
	 * Endpoints needed:
	 * GET /api/calc/subjects
	 */
	{
		path: '/home',
		component: DashboardLayout,
		children: [
			{
				path: '',
				name: 'Home',
				component: () => {
					const user = JSON.parse(
						localStorage.getItem('user') || '{}',
					)
					return user.isCollaborator
						? import('@/views/HomeColaborator/index.vue')
						: import('@/views/Home/index.vue')
				},
				// component: () => import('@/views/Home/index.vue'),
				meta: {
					title: 'Home',
					logNavigation: true,
				},
			},
		],
	},

	{
		path: '/documentos-internos',
		component: DashboardLayout,
		children: [
			{
				path: '',
				name: 'Documentos Internos',
				component: () => import('@/views/InternalDocuments/index.vue'),
				meta: {
					title: 'Documentos Internos',
					logNavigation: true,
				},
			},
		],
	},

	{
		path: '/autenticacao-tribunais',
		component: DashboardLayout,
		children: [
			{
				path: '',
				name: 'Autenticação de tribunais',
				component: () => import('@/views/OTPApp/index.vue'),
				meta: {
					title: 'Autenticação de tribunais',
					logNavigation: true,
				},
			},
		],
	},

	{
		path: '/prazos/classificacao',
		component: DashboardLayout,
		children: [
			{
				path: '',
				name: 'Home',
				component: () => import('@/views/RatingDeadlines/index.vue'),
				meta: {
					title: 'Classificação de prazos',
					logNavigation: true,
				},
			},
		],
	},

	// {
	// 	path: '/home3',
	// 	component: DashboardLayout,
	// 	children: [
	// 		{
	// 			path: '',
	// 			name: 'Home3',
	// 			component: () => import('@/views/Home3/index.vue'),
	// 			meta: {
	// 				title: 'Home3',
	// 				logNavigation: true,
	// 			},
	// 		},
	// 	],
	// },

	// {
	// 	path: '/home4',
	// 	component: DashboardLayout,
	// 	children: [
	// 		{
	// 			path: '',
	// 			name: 'Home4',
	// 			component: () => import('@/views/Home4/index.vue'),
	// 			meta: {
	// 				title: 'Home4',
	// 				logNavigation: true,
	// 			},
	// 		},
	// 	],
	// },
]

const routesContent: Array<RouteConfig> = [
	{
		path: '/conteudos',
		component: DashboardLayout,
		children: [
			{
				path: '',
				name: 'Conteúdos',
				component: () => import('@/views/Blog/MainPage/index.vue'),
				meta: {
					title: 'Conteúdos',
					logNavigation: true,
				},
			},
		],
	},

	{
		path: '/conteudos/navegar',
		component: DashboardLayout,
		children: [
			{
				path: '',
				name: 'Navegação Conteúdos',
				component: () => import('@/views/Blog/Browse/index.vue'),
				meta: {
					title: 'Navegação Conteúdos',
					logNavigation: true,
				},
			},
		],
	},

	{
		path: '/gerenciar-conteudos/tags',
		component: DashboardLayout,
		children: [
			{
				path: '',
				name: 'Gerenciar Tags',
				component: () => import('@/views/Blog/ContentTags/index.vue'),
				meta: {
					title: 'Gerenciar Tags',
					logNavigation: true,
				},
			},
		],
	},

	{
		path: '/gerenciar-conteudos/podcasts',
		component: DashboardLayout,
		children: [
			{
				path: '',
				name: 'Gerenciar Podcasts',
				component: () => import('@/views/Blog/Podcasts/index.vue'),
				meta: {
					title: 'Gerenciar Podcasts',
					logNavigation: true,
				},
			},
		],
	},

	{
		path: '/gerenciar-conteudos/laminas',
		component: DashboardLayout,
		children: [
			{
				path: '',
				name: 'Gerenciar Laminas',
				component: () => import('@/views/Blog/Laminas/index.vue'),
				meta: {
					title: 'Gerenciar Laminas',
					logNavigation: true,
				},
			},
		],
	},
]

const routesAuxiliary: Array<RouteConfig> = [
	{
		path: '/login',
		name: 'Login',
		component: () => import('@/views/Login/index.vue'),
		meta: { title: '' },
	},

	{
		path: '/temp-tag',
		name: 'TempTag',
		component: () => import('@/views/TempTag/index.vue'),
		meta: { title: 'Consultar Tags' },
	},

	{
		path: '/minha-conta',
		component: DashboardLayout,
		children: [
			{
				path: '',
				name: 'Minha Conta',
				component: () => import('@/views/MyAccount/index.vue'),
				meta: {
					title: 'Minha Conta',
					logNavigation: true,
				},
			},
		],
	},

	{
		path: '/recuperar-senha',
		name: 'Recuperar Senha',
		component: () => import('@/views/PasswordRecovery/index.vue'),
		meta: { title: '' },
	},

	{
		path: '/login/google-success',
		name: 'Login Sucesso Google',
		component: () => import('@/views/Login/GoogleSuccess/index.vue'),
		meta: { title: '' },
	},

	{
		path: '/configuracoes',
		component: DashboardLayout,
		children: [
			{
				path: '',
				name: 'Settings',
				component: () => import('@/views/Settings/index.vue'),
				meta: {
					title: '',
					logNavigation: true,
				},
			},
		],
	},
]

const routesClient: Array<RouteConfig> = [
	/**
	 * Endpoints needed:
	 * GET /api/groups
	 */
	{
		path: '/clientes',
		component: DashboardLayout,
		children: [
			{
				path: '',
				name: 'Clientes',
				component: () => import('@/views/Groups/index.vue'),
				meta: {
					title: 'Clientes',
					logNavigation: true,
				},
			},
		],
		pathToRegexpOptions: { strict: true },
	},

	{
		path: '/clientes/:clientId?',
		component: DashboardLayout,
		children: [
			{
				path: '',
				name: 'GroupsDetail',
				component: () => import('@/views/GroupsDetail/index.vue'),
				meta: {
					title: '',
					logNavigation: true,
				},
			},
		],
	},

	{
		path: '/laminas/gerenciar-lamina/:laminaId',
		component: DashboardLayout,
		children: [
			{
				path: '',
				name: 'GerenciarLamina',
				component: () => import('@/views/GerenciarLamina/index.vue'),
				meta: {
					title: '',
					logNavigation: true,
				},
			},
		],
	},
]

const routesAuxiliaryLists: Array<RouteConfig> = [
	{
		path: '/listas-auxiliares/tipos-de-acao',
		component: DashboardLayout,
		children: [
			{
				path: '',
				name: 'Domain-LawsuitTypes',
				component: () =>
					import('@/views/Domains/LawsuitTypes/index.vue'),
				meta: {
					title: '',
					logNavigation: true,
				},
			},
		],
	},

	/**
	 * Endpoints needed:
	 * GET /api/law-firms
	 */
	{
		path: '/listas-auxiliares/escritorios',
		component: DashboardLayout,
		children: [
			{
				path: '',
				name: 'Domain-LawFirms',
				component: () => import('@/views/Domains/LawFirms/index.vue'),
				meta: {
					title: 'Escritórios',
					logNavigation: true,
				},
			},
		],
	},

	{
		path: '/listas-auxiliares/partes-contrarias',
		component: DashboardLayout,
		children: [
			{
				path: '',
				name: 'Domain-Parts',
				component: () => import('@/views/Domains/Parts/index.vue'),
				meta: {
					title: 'Partes contrárias',
					logNavigation: true,
				},
			},
		],
	},

	/**
	 * Endpoints needed:
	 * GET /api/market-sectors
	 */
	{
		path: '/listas-auxiliares/setores',
		component: DashboardLayout,
		children: [
			{
				path: '',
				name: 'Domain-MarketSectors',
				component: () =>
					import('@/views/Domains/MarketSectors/index.vue'),
				meta: {
					title: 'Setores',
					logNavigation: true,
				},
			},
		],
	},

	{
		path: '/listas-auxiliares/situacao-atual-jud',
		component: DashboardLayout,
		children: [
			{
				path: '',
				name: 'Domain-SituationsJud',
				component: () =>
					import('@/views/Domains/SituationsJud/index.vue'),
				meta: {
					title: 'Situação Atual - Judicial',
					logNavigation: true,
				},
			},
		],
	},

	{
		path: '/listas-auxiliares/situacao-atual-adm',
		component: DashboardLayout,
		children: [
			{
				path: '',
				name: 'Domain-SituationsAdm',
				component: () =>
					import('@/views/Domains/SituationsAdm/index.vue'),
				meta: {
					title: 'Situação Atual - Administrativo',
					logNavigation: true,
				},
			},
		],
	},

	/**
	 * Endpoints needed:
	 * GET /api/courthouses
	 */
	{
		path: '/listas-auxiliares/tribunais',
		component: DashboardLayout,
		children: [
			{
				path: '',
				name: 'Domain-Courthouses',
				component: () =>
					import('@/views/Domains/Courthouses/index.vue'),
				meta: {
					title: 'Tribunais',
					logNavigation: true,
				},
			},
		],
	},

	{
		path: '/listas-auxiliares/tramitacao-atual',
		component: DashboardLayout,
		children: [
			{
				path: '',
				name: 'Domain-Courts',
				component: () => import('@/views/Domains/Courts/index.vue'),
				meta: {
					title: 'Tramitação atual',
					logNavigation: true,
				},
			},
		],
	},

	/**
	 * Endpoints needed:
	 * GET /api/calc/subjects
	 * POST /api/calc/subjects/:subjectId
	 */
	{
		path: '/listas-auxiliares/teses-tributarias',
		component: DashboardLayout,
		children: [
			{
				path: '',
				name: 'CalcSubjects2',
				component: () => import('@/views/CalcSubjects2/index.vue'),
				meta: {
					title: 'Teses',
					logNavigation: true,
				},
			},
		],
	},
]

const routes: Array<RouteConfig> = [
	{
		path: '/',
		redirect: '/home',
		meta: { title: '' },
	},

	...routesHomes,
	...routesContent,
	...routesAuxiliary,
	...routesClient,
	...routesAuxiliaryLists,


	{
		path: '/prazos',
		component: DashboardLayout,
		children: [
			{
				path: '',
				name: 'Prazos',
				component: () => import('@/views/Deadlines/index.vue'),
			},
		],
		pathToRegexpOptions: { strict: true },
		meta: { title: 'Prazos' },
	},

	{
		path: '/relatorio/:clientId?',
		component: DashboardLayout,
		children: [
			{
				path: '',
				name: 'Report',
				component: () => import('@/views/Report/index.vue'),
				meta: {
					title: '',
					logNavigation: true,
				},
			},
		],
		pathToRegexpOptions: { strict: true },
	},

	/**
	 * Endpoints needed:
	 * GET /api/calc/subjects
	 */
	{
		path: '/calculadora',
		component: DashboardLayout,
		children: [
			{
				path: '',
				name: 'Calculadora',
				component: () => import('@/views/Calculator/index.vue'),
				meta: {
					title: 'Calculadora',
					logNavigation: true,
				},
			},
		],
	},

	{
		path: '/termometro',
		component: DashboardLayout,
		children: [
			{
				path: '',
				name: 'Thermometer',
				component: () => import('@/views/Thermometer/index.vue'),
				meta: {
					title: 'Termômetro',
					logNavigation: true,
				},
			},
		],
	},

	{
		path: '/gerenciar-termometro',
		component: DashboardLayout,
		children: [
			{
				path: '',
				name: 'ThermometerManagement',
				component: () =>
					import('@/views/Thermometer/Management/index.vue'),
				meta: {
					title: 'Gerenciar termômetro',
					logNavigation: true,
				},
			},
		],
	},

	{
		path: '/gerenciar-relatorios',
		component: DashboardLayout,
		children: [
			{
				path: '',
				name: 'ReportManager',
				component: () => import('@/views/ReportManager/index.vue'),
				meta: {
					title: 'Gerenciar relatórios',
				},
			},
		],
	},

	{
		path: '/gerenciar-prazos',
		component: DashboardLayout,
		children: [
			{
				path: '',
				name: 'DeadlineManager',
				component: () => import('@/views/DeadlineManager/index.vue'),
				meta: {
					title: 'Gerenciar prazos',
				},
			},
		],
	},

	{
		path: '/iniciais',
		component: DashboardLayout,
		children: [
			{
				path: '',
				name: 'InitialManagement',
				component: () => import('@/views/InitialManagement/index.vue'),
				meta: {
					title: 'Iniciais',
				},
			},
		],
	},

	{
		path: '/gerenciar-ferias',
		component: DashboardLayout,
		children: [
			{
				path: '',
				name: 'Vacations',
				component: () => import('@/views/Vacations/index.vue'),
				meta: {
					title: 'Gerenciar férias',
				},
			},
		],
	},

	{
		path: '/timeline',
		component: DashboardLayout,
		children: [
			{
				path: '',
				name: 'ThermometerTimeLine',
				component: () =>
					import('@/views/ThermometerTimeLine/index.vue'),
				meta: {
					title: 'TimeLine',
				},
			},
		],
	},

	{
		path: '/gerenciar-mapa-tributario',
		component: DashboardLayout,
		children: [
			{
				path: '',
				name: 'TributaryMapManagement',
				component: () =>
					import('@/views/TributaryMapManagement/index.vue'),
				meta: {
					title: 'Gerenciar mapa tributário',
					logNavigation: true,
				},
			},
		],
	},
	{
		path: '/mapa-tributario',
		component: DashboardLayout,
		children: [
			{
				path: '',
				name: 'TributaryMap',
				component: () => import('@/views/TributaryMap/index.vue'),
				meta: {
					title: 'Mapa Tributário',
					logNavigation: true,
				},
			},
		],
	},

	/**
	 * Endpoints needed:
	 * GET /api/email_logs
	 * POST /api/email_logs
	 * POST /api/email_logs/send
	 */
	{
		path: '/envio-de-relatorios/:seeAll?',
		component: DashboardLayout,
		children: [
			{
				path: '',
				name: 'ReportSending',
				component: () => import('@/views/Emails/index.vue'),
				meta: {
					title: '',
					logNavigation: true,
				},
			},
		],
	},

	/**
	 * Endpoints needed:
	 * GET /api/groups
	 * POST /api/users
	 */
	{
		path: '/usuarios/novo',
		component: DashboardLayout,
		children: [
			{
				path: '',
				name: 'CreateUser',
				component: () => import('@/views/Users/Create/index.vue'),
				meta: {
					title: 'Criar Novo Usuário',
					logNavigation: true,
				},
			},
		],
	},

	/**
	 * Endpoints needed:
	 * GET /api/groups
	 * GET /api/users/:userId
	 * POST /api/users/:userId
	 * POST /api/users/:userId/password
	 */
	{
		path: '/usuarios/editar/:userId',
		component: DashboardLayout,
		children: [
			{
				path: '',
				name: 'EditUser',
				component: () => import('@/views/Users/Edit/index.vue'),
				meta: {
					title: 'Editar Usuário',
					logNavigation: true,
				},
			},
		],
	},

	/**
	 * Endpoints needed:
	 * GET /api/users
	 */
	{
		path: '/usuarios',
		component: DashboardLayout,
		children: [
			{
				path: '',
				name: 'Users',
				component: () => import('@/views/Users/index.vue'),
				meta: {
					title: 'Usuários',
					logNavigation: true,
				},
			},
		],
	},

	{
		path: '/challenge',
		name: 'Challenge',
		component: () => import('@/views/Challenge/index.vue'),
		meta: { title: '' },
	},

	{
		path: '/challenge/resultado',
		name: 'ChallengeResult',
		component: () => import('@/views/ChallengeResult/index.vue'),
		meta: { title: '' },
	},

	/**
	 * Endpoints needed:
	 * GET /api/permissions/users
	 * GET /api/permissions/roles
	 * POST /api/permissions/roles/:roleKey/addUser
	 * DELETE /api/permissions/roles/:roleKey/removeUser
	 */
	{
		path: '/permissoes/usuarios',
		component: DashboardLayout,
		children: [
			{
				path: '',
				name: 'Permmissions Users',
				component: () => import('@/views/Permissions/Users/index.vue'),
				meta: {
					title: 'Controle de Acesso - Usuários',
					logNavigation: true,
				},
			},
		],
	},

	/**
	 * Endpoints needed:
	 * GET /api/permissions/roles
	 * GET /api/permissions/roles/:roleKey
	 * DELETE /api/permissions/roles/:roleKey
	 * POST /api/permissions/roles
	 * POST /api/permissions/roles/:roleKey/removePermissions
	 * POST /api/permissions/roles/:roleKey/addPermissions
	 */
	{
		path: '/permissoes/grupos',
		component: DashboardLayout,
		children: [
			{
				path: '',
				name: 'Permmissions Groups',
				component: () => import('@/views/Permissions/Groups/index.vue'),
				meta: {
					title: 'Controle de Acesso - Grupos',
					logNavigation: true,
				},
			},
		],
	},

	{
		path: '/processos1',
		component: DashboardLayout,
		children: [
			{
				path: '',
				name: 'Collection',
				component: () => import('@/views/Collection/index.vue'),
				meta: {
					title: 'Processos',
					logNavigation: true,
				},
			},
		],
	},

	{
		path: '/processos',
		component: DashboardLayout,
		children: [
			{
				path: '',
				name: 'Collection',
				component: () => import('@/views/CollectionV2/index.vue'),
				meta: {
					title: 'Processos',
					logNavigation: true,
				},
			},
		],
	},

	{
		path: '/contas-correntes',
		component: DashboardLayout,
		children: [
			{
				path: '',
				name: 'Contas correntes',
				component: () => import('@/views/CheckingAccounts/index.vue'),
				meta: {
					title: 'Contas correntes',
					logNavigation: true,
				},
			},
		],
	},

	/* 
	ocultando conta corrente
	{
		path: '/conta-corrente',
		component: DashboardLayout,
		children: [
			{
				path: '',
				name: 'Conta corrente',
				component: () =>
					import('@/views/CheckingAccountHome/index.vue'),
				meta: {
					title: 'Conta corrente',
					logNavigation: true,
				},
			},
		],
	},
	*/
	{
		path: '/minhas-propostas',
		component: DashboardLayout,
		children: [
			{
				path: '',
				name: 'Minhas Propostas',
				component: () => import('@/views/Proposals/index.vue'),
			},
		],
		pathToRegexpOptions: { strict: true },
		meta: { title: 'Minhas Propostas' },
	},

	{
		path: '/finalizar-cadastro/:inviteCode',
		name: 'Invite',
		component: () => import('@/views/Invite/index.vue'),
		meta: { title: 'Convite' },
	},

	{
		path: '/teste-notificacoes',
		name: 'Teste',
		component: () => import('@/views/TestNotifications/index.vue'),
		meta: { title: 'Teste Notificações' },
	},

	{
		path: '/assistente-juridico',
		component: DashboardLayout,
		children: [
			{
				path: '',
				name: 'AssistenteJuridico',
				component: () => import('@/views/AssistenteJuridico/index.vue'),
				meta: {
					title: 'Assistente Jurídico',
					logNavigation: true,
				},
			},
		],
	},

	{
		path: '/acesso-proibido',
		component: DashboardLayout,
		children: [
			{
				path: '',
				name: 'Forbidden',
				component: Forbidden,
				meta: {
					title: 'Acesso Proibido',
					logNavigation: true,
				},
			},
		],
	},

	{
		path: '/test',
		component: DashboardLayout,
		children: [
			{
				path: '',
				name: 'Forbidden2',
				component: () => import('@/views/Test/index.vue'),
				meta: {
					title: 'Acesso Proibido',
					logNavigation: true,
				},
			},
		],
	},

	{
		path: '/reforma-tributaria',
		component: DashboardLayout,
		children: [
			{
				path: '',
				name: 'SART',
				component: () => import('@/views/SART/index.vue'),
				meta: {
					title: 'SART — Reforma Tributária',
					logNavigation: true,
				},
			},
		],
	},

	{
		path: '/admin/reforma-tributaria',
		component: DashboardLayout,
		children: [
			{
				path: '',
				name: 'SARTAdmin',
				component: () => import('@/views/SARTAdmin/index.vue'),
				meta: {
					title: 'SART — Configurações Admin',
					logNavigation: true,
				},
			},
		],
	},

	{
		path: '*',
		component: DashboardLayout,
		children: [
			{
				path: '',
				name: 'NotFound',
				component: NotFound,
				meta: { title: 'Página Não Encontrada' },
			},
		],
	},
]

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes,
	linkActiveClass: 'active',
})

router.afterEach((to) => {
	Vue.nextTick(() => {
		// @ts-ignore
		document.title =
			(to.meta.title ? to.meta.title + ' - ' : '') + 'Portal Locatelli'
	})

	if (to.meta.logNavigation) {
		api.post('/api/logging/navigation', { route: to.fullPath })
	}
})

export default router
